import { InfoFirmaDTO } from "./protocollo/info-firmaDTO";
import { UtenteDTO } from "./utenteDTO";

export class DatiFirmaDTO {

    dataVerifica: number;

    statoVerifica: boolean;

    info: InfoFirmaDTO[];

    firmatario: UtenteDTO;

}
